import React from "react";
import { Col, Typography } from "antd";

import CustomRow from "../../shared/costum-row/costum-row";
import { CONTACT_CONTENT } from "../../constants/content/pages/contact";

import "./styles.scss";
import ContactForm from "../contact-form/contact-form";
import useBreakpoints from "../../hooks/use-breakpoints";
import useScreenResolution from "../../hooks/use-screen-resolution";
import { BREAKPOINTS } from "../../constants/styles";

const { Text, Title } = Typography;

const ContactUs = () => {
  const currentBreakpoint = useBreakpoints();
  const screenResolution = useScreenResolution();
  const isLargeDesktopMidBreakPoint = screenResolution.width <= 1599;
  const isSmallDesktopBrakePoint = screenResolution.width <= 1279;
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <CustomRow
      className="ContactUs"
      gutter={
        isMobile ? [0, 80] : isSmallDesktopBrakePoint ? [0, 100] : [0, 120]
      }
    >
      <Col span={24}>
        <Title className="ContactUs-title">{CONTACT_CONTENT.headline.title}</Title>
      </Col>
      <Col span={24}>
        <CustomRow
          justify={"space-between"}
          gutter={isMobile ? [0, 60] : [0, 0]}
        >
          <Col xxl={12} xl={12} lg={15} md={15} sm={24} xs={24}>
            <ContactForm />
          </Col>
          <Col xxl={8} xl={8} lg={6} md={6} sm={24} xs={24}>
            <CustomRow gutter={!isSmallDesktopBrakePoint ? [0, 134] : [0, 40]}>
              <Col span={24}>
                <CustomRow>
                  <Col span={24}>
                    <CustomRow
                      gutter={!isLargeDesktopMidBreakPoint ? [20, 0] : [0, 40]}
                    >
                      <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                        <CustomRow gutter={[0, 10]}>
                          <Col span={15}>
                            <Title className="ContactUs-info-title">
                              E-Mail
                            </Title>
                          </Col>
                          <Col span={15}>
                            <Title className="ContactUs-info-content">
                              {CONTACT_CONTENT.contactInfo.email}
                            </Title>
                          </Col>
                        </CustomRow>
                      </Col>
                      <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                        <CustomRow gutter={[0, 10]}>
                          <Col span={15}>
                            <Title className="ContactUs-info-title">
                              Phone Number
                            </Title>
                          </Col>
                          <Col span={15}>
                            <Title className="ContactUs-info-content">
                              {CONTACT_CONTENT.contactInfo.phone}
                            </Title>
                          </Col>
                        </CustomRow>
                      </Col>
                    </CustomRow>
                  </Col>
                </CustomRow>
              </Col>
              <Col span={24}>
                <CustomRow gutter={[0, 10]}>
                  <Col span={15}>
                    <Title className="ContactUs-info-title">Location</Title>
                  </Col>
                  <Col span={15}>
                    <Title className="ContactUs-info-content">
                      {CONTACT_CONTENT.contactInfo.location}
                    </Title>
                  </Col>
                </CustomRow>
              </Col>
            </CustomRow>
          </Col>
        </CustomRow>
      </Col>
    </CustomRow>
  );
};

export default ContactUs;
